var Theme = Theme || {};

Theme.BookToc = (function ($) {
    var $liElem = $('ul.bookToc li.expandable');

    return {
        init: _init
    };

    function displayExpandCollapse() {
        if ($liElem && $liElem.length) {
            $('.js-toc-expand-collapse').addClass('enabled');
        }
    }

    function expandCollapseEvents() {
        $('.toc-expand-collapse .js-show-all').on('click', function () {
            $liElem.not('.expanded').addClass('expanded');
        });

        $('.toc-expand-collapse .js-hide-all').on('click', function () {
            $liElem.removeClass('expanded');
        });
    }

    function _init() {
        displayExpandCollapse();
        expandCollapseEvents();
    }

})(jQuery);

// If we are in a module context, export this module
'object' === typeof module && module.exports && (module.exports = Theme.BookToc);